module.exports = __webpack_public_path__ + "img/head.32c8c084.jpg";